<template>
    <div>
        <div class="signup-header row border-bottom-light row justify-content-sm-center">
            <div class="col-sm-6">
                <h5 class="color-6">2. Details</h5>
                <h2>Can you tell us more about {{ brand }}.</h2>
                <h4>Just the usual stuff.</h4>
            </div>
        </div>

        <div class="row justify-content-sm-center">
            <div class="col-sm-6">
                <form class="shaded" @submit.prevent.stop="processForm" novalidate>
                    <div class="form-group" v-if="sizes">
                        <label class="full">Company size</label>

                        <v-select
                            v-model="selectedSize"
                            placeholder="How many employees do you have?"
                            :options="sizes"
                            label="description"
                            :searchable="false"
                            @input="updateSize">
                        </v-select>
                    </div>

                    <div class="row form-group">
                        <div class="col-sm-6" :class="{ error: $v.form.companyEmail.$error }">
                            <label class="full">
                                Email (for customer contact)
                                <input v-model.trim="form.companyEmail" type="email" placeholder="Please add your email" @input="$v.form.companyEmail.$touch">
                            </label>

                            <div v-if="$v.form.companyEmail.$error" class="messages">
                                <span v-if="!$v.form.companyEmail.required">Email is required.</span>
                                <span v-if="!$v.form.companyEmail.email">Must be a valid email</span>
                            </div>
                        </div>

                        <div class="col-sm-6" :class="{ error: $v.form.companyPhone.$error }">
                            <label class="full">
                                Phone (for customer contact)
                                <input v-model="form.companyPhone" type="tel" placeholder="Please add your phone no." @input="$v.form.companyPhone.$touch">
                            </label>

                            <div v-if="$v.form.companyPhone.$error" class="messages">
                                <span v-if="!$v.form.companyPhone.required">Business phone is required.</span>
                                <span v-if="!$v.form.companyPhone.numeric">Must be a phone number.</span>
                                <span v-if="!$v.form.companyPhone.minLength">Business phone must have at least 9 numbers.</span>
                            </div>
                        </div>
                    </div>

                    <location-fields @locationFieldsChanged="updateLocationFields"></location-fields>

                    <div class="form-group">
                        <label class="full mb-4">Your sales channels</label>

                        <label class="full mb-2">
                            <checkbox v-model="form.salesStore">
                                I'm selling in my own store
                            </checkbox>
                        </label>

                        <label class="full mb-2">
                            <checkbox v-model="form.salesWebsite">
                                I'm selling in my website
                            </checkbox>
                        </label>

                        <label class="full mb-2">
                            <checkbox v-model="form.salesOtherAgents">
                                I have other agents selling my services.
                            </checkbox>
                        </label>

                        <label class="full mb-2">
                            <checkbox v-model="form.salesOtherWebsites">
                                I'm selling in others websites.
                            </checkbox>
                        </label>

                        <label class="full mb-2">
                            <checkbox v-model="form.salesNone">
                                I'm starting and have no sales yet.
                            </checkbox>
                        </label>

                        <label class="full mb-2">
                            <checkbox v-model="form.salesOther">
                                Other
                            </checkbox>
                        </label>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <router-link :to="{ name: 'auth.signup.supplier.create' }">
                                <input type="button" class="btn tertiary widest full" value="Back">
                            </router-link>
                        </div>
                        <div class="col-md-6">
                            <input type="submit" class="btn action widest full" value="Finish" :class="{'opacity-50':submittingRegistration}" :disabled="!$v.form.$dirty || $v.form.$error">
                        </div>
                    </div>

                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import LocationFields from '../LocationFields'
    import { required, email, minLength, numeric } from 'vuelidate/lib/validators'

    export default {
        data: function() {
            return {
                step: 3,
                form: {
                    companyEmail: '',
                    companyPhone: ''
                },
                selectedSize: null,
                submittingRegistration: false
            }
        },
        validations: {
            form: {
                companyEmail: {
                    //required,
                    email,
                },
                companyPhone: {
                    //required,
                    minLength: minLength(9),
                    numeric
                }
            }
        },
        created: function() {
            // Redirect if we landed here without having passed through the needed steps

            if (this.accountSetup.type !== 'supplier') {
                this.resetAccountSetup('supplier');
                this.$router.push({ name: 'auth.signup' });
            }
            else {
                this.form = this.accountSetup;
                this.eventHub.$emit('sidebar', 'create');
                this.eventHub.$emit('topLink', 'login');
            }
        },
        mounted: function() {
            // this.form.companyEmail = 'plu@ralo.com';
            // this.form.companyPhone = '916392040';
        },
        computed: {
            ...mapGetters([
                'accountSetup'
            ]),
            brand: function() {
                if (this.accountSetup.brand !== undefined) {
                    return this.accountSetup.brand;
                }
            }
        },
        asyncComputed: {
            async sizes() {
                try {
                    let response = await axios.get('/api/settings/GetSupplierSizeList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        this.form.size = response.data[0];
                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error.response.data.message);
                }
            },
        },
        methods: {
            ...mapActions([
                'resetAccountSetup',
                'updateAccountSetup',
                'register',
                'registerSupplier',
            ]),
            processForm: function() {
                if(!this.submittingRegistration){
                    this.form.step = this.step + 1;

                    // Update account setup data

                    this.updateAccountSetup(this.form);

                    // Create a supplier account via API
                    this.submittingRegistration = true
                    this.registerSupplier(this.parseQueryString(this.accountSetup)).then(() => {
                        this.submittingRegistration = false
                        this.resetAccountSetup('supplier');
                    });

                } else {
                    this.$toasted.info('Already submitting your registration, please wait');
                }
            },
            updateSize: function() {
                this.form.size = this.selectedSize.id || null;
            },
            updateLocationFields: function(fields) {
                for (var key in fields) {
                    if (fields.hasOwnProperty(key)) {
                        this.form[key] = fields[key];
                    }
                }
            }
        },
        components: {
            vSelect: extendedVSelect,
            LocationFields,
        }
    }
</script>



// WEBPACK FOOTER //
// Step3.vue?9a6be4ca